import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: 'Anuluj',
  save: 'Zatwierdź',
  title: 'Zmień wartość etykiety odpowiedzi',
  labelText: 'Etykieta odpowiedzi',
});
